import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';
import { getLcDashboardViewTypes } from 'src/fetch/lcDashboard';

const dashboardViewTypesAdapter = getAdapter({ idFieldName: 'value' });

export const fetchDashboardViewTypes = createAsyncThunk(
  'dashboardViewTypes/fetchData',
  async () => {
    return await getLcDashboardViewTypes();
  }
);

const dashboardViewTypesSlice = createSlice({
  name: 'dashboardViewTypes',
  initialState: dashboardViewTypesAdapter.getInitialState(),
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchDashboardViewTypes.fulfilled, (state, action) => {
      dashboardViewTypesAdapter.setAll(state, action.payload);
    });
  }
});

const selectors = dashboardViewTypesAdapter.getSelectors(({ dashboardViewTypes }) => dashboardViewTypes);

export const getDashboardViewTypes = (state) => selectors.selectAll(state);

export const { setDashboardViewTypes } = dashboardViewTypesSlice.actions;

export default dashboardViewTypesSlice.reducer;
